import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  fieldsContainer: {
    margin: 0,
    width: '100%',
  },
  grid: {
    padding: `${theme.spacing(2, 2, 2, 0)} !important`,
    width: '100%',
  },
  simpleForm: {
    boxShadow: 'none',
    padding: 0,
    background: 'none',
  },
  fieldGroup: {
    position: 'relative',
    padding: 20,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 20,
  },
  fieldGroupTitle: {
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    top: -17,
  },
  fullName: {
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
    },
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '1.25rem',
  },
  editDate: {
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  suggestionStyle: {
    position: 'absolute',
    width: '100%',
    zIndex: 10,
    '& > ul': {
      listStyle: 'none',
      margin: 0,
      padding: 0,
    },
  },
  addBtn: {
    marginTop: 40,
  },
}));
